import { DateTime } from 'luxon';
import { ConsumerGroupOrderFieldsFragment, OrderType } from 'src/gqlReactTypings.generated.d';
import { ButtonColors } from 'src/shared/design-system/Buttons';
import { Pencil } from 'src/shared/design-system/Icon/Pencil';
import { useHistory } from 'src/shared/hooks/useHistory';
import { Routes } from 'src/shared/Routes';
import styled from 'styled-components';
import { Colors, Spacing } from 'web-common/src/shared/styles';
import { ConsumerOrdersCardBody } from './ConsumerOrdersCardBody';
import { ConsumerOrdersCardHeader } from './ConsumerOrdersCardHeader';
import { MessageButton } from './MessageButton';
import { ReorderButton } from './ReorderButton';
import { ReviewButton } from './ReviewButton';
import { ShareDropdownButton } from './ShareDropdownButton';
import { SkipButton } from './SkipButton';
import { OrdersCard, OrdersListRowButton, OrdersListRowButtonContainer } from './styles';
import { TabNames } from './utilities';

interface ConsumerOrdersCardProps {
  groupOrder: ConsumerGroupOrderFieldsFragment;
  activeTab: TabNames;
  showReviewModal?: () => void;
  hasActiveSubscription?: boolean;
}

const EditButtonStyled = styled(OrdersListRowButton).attrs(() => ({ color: ButtonColors.WHITE }))`
  color: ${Colors.GRAY_DARK_30};
  border: 2px solid ${Colors.RADISH};
`;

const EditButtonIcon = styled(Pencil)`
  width: ${Spacing.SINGLE};
  margin-right: ${Spacing.QUARTER};
`;

export const ConsumerOrdersCard = ({
  groupOrder,
  activeTab,
  showReviewModal,
  hasActiveSubscription,
}: ConsumerOrdersCardProps) => {
  const isMealPlanOrder = groupOrder.orderType === OrderType.MealPlan;
  const startOfToday = DateTime.now().startOf('day');
  const isUpcomingOrder = DateTime.fromISO(groupOrder.deliveryDate) > startOfToday;

  const history = useHistory();
  return (
    <OrdersCard header={<ConsumerOrdersCardHeader groupOrder={groupOrder} activeTab={activeTab} />}>
      <ConsumerOrdersCardBody orders={groupOrder.orders} />
      <OrdersListRowButtonContainer>
        <ReviewButton groupOrder={groupOrder} showReviewModal={showReviewModal} />
        {!isMealPlanOrder && <ReorderButton groupOrder={groupOrder} primary={isUpcomingOrder} />}
        {isMealPlanOrder && activeTab !== TabNames.PREVIOUS && hasActiveSubscription && (
          <EditButtonStyled
            onClick={() => {
              history.push(Routes.CONSUMER_MEAL_PLANS_UPCOMING_ORDER);
            }}>
            <EditButtonIcon />
            Manage Order
          </EditButtonStyled>
        )}
        {(!isMealPlanOrder || (isMealPlanOrder && !hasActiveSubscription)) && <SkipButton groupOrder={groupOrder} />}
        {!isMealPlanOrder || (activeTab === TabNames.PREVIOUS && <ShareDropdownButton groupOrder={groupOrder} />)}
        <MessageButton groupOrder={groupOrder} />
      </OrdersListRowButtonContainer>
    </OrdersCard>
  );
};
